/** Canonical validation messages — aligned with legacy Formik/Yup standards. */

export const RequiredMessage = 'Required field';

export const maxCharMessage = (textLimit: number) =>
  `Must not exceed ${textLimit} characters`;

/** @deprecated Use maxCharMessage — kept for legacy re-export compatibility */
export const MaxCharMessage = maxCharMessage;

export const DigitsOnlyMessage = 'Must be only digits';

export const EmailMessage = 'Invalid Email';

export const AlphanumericMessage = 'Must be alphanumeric';

export const NotBlankMessage = 'Must not contain blank spaces';

export const TickerMessage = 'Invalid Ticker';

export const InvalidDateMessage = 'Invalid date';

export const percentageRangeMessage = (min: number, max: number) =>
  `Must be between ${min} and ${max}`;
